import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { catchError, throwError } from "rxjs";
import { AuthStorage } from "../auth/storage/auth-storage";
import { readSession } from "../shared/utils/session.util";

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authStorage = inject(AuthStorage);

  const session = readSession();
  const token = session?.accessToken;

  const authReq = token ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req;

  return next(authReq).pipe(
    catchError((error) => {
      if (error.status === 401 && !req.url.includes("/auth/login")) {
        authStorage.logout();
      }
      return throwError(() => error);
    })
  );
};
